import { render } from "./WeightLossContentEn.vue?vue&type=template&id=60a952de&scoped=true"
import script from "./WeightLossContentEn.vue?vue&type=script&lang=js"
export * from "./WeightLossContentEn.vue?vue&type=script&lang=js"

import "./WeightLossContentEn.vue?vue&type=style&index=0&id=60a952de&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a952de"]])

export default __exports__